module.exports = {
  "id": "screenwrap",
  "color": "blue",
  "title": "screenwrap",
  "icon": "screenwrap",
  "description": "Wrap around the screen.",
  "category": "rules",
  "searchTags": ["infinite","around","side scroll", "edge"],
  "exposedVariables": [
    {
      "tooltip":"Set where the gamescreen's left edge is",
      "variableName": "X Minimum",
      "spriteName": "$glitch_target",
      "input": {
        "type": "slider",
        "min": "-240",
        "max": "240",
        "value": 240,
        "step": "1"
      },
      "value": "-235"
    },
    {
      "tooltip":"Set where the gamescreen's right edge is",
      "variableName": "X Maximum",
      "spriteName": "$glitch_target",
      "input": {
        "type": "slider",
        "min": "-240",
        "max": "240",
        "value": -240,
        "step": "1"
      },
      "value": "235"
    },
    {
      "tooltip":"Set where the gamescreen's bottom edge is",
      "variableName": "Y Minimum",
      "spriteName": "$glitch_target",
      "input": {
        "type": "slider",
        "min": -180,
        "max": 180,
        "value": -180,
        "step": "1"
      },
      "value": "-175"
    },
    {
      "tooltip":"Set where the gamescreen's top edge is",
      "variableName": "Y Maximum",
      "spriteName": "$glitch_target",
      "input": {
        "type": "slider",
        "min": -180,
        "max": 180,
        "value": 180,
        "step": "1"
      },
      "value": "175"
    }
  ],
  "info": [
    {
      "text": "Make a piece wrap around the screen when it is moved all the way to an edge",
      "image": "provision/glitches/screenwrap/screenwrap.gif"
    }
  ],
  "codeImage": "provision/glitches/screenwrap/screenwrap.png",
  "code": null,
  "zip": null,
  "sb3": null
};